<template>
  <div class="flex flex-row gap-2">
    <div
      @click="input(option.value)"
      :key="option.value"
      v-for="option in options"
      :class="` 
        flex items-center cursor-pointer px-1 transition-all
        ${colorHighlight('container', option, ['border', 'color', 'background'])}
      `"
    >
      <component
        :is="iconComponent"
        :icon="option.icon"
        :class="
          iconComponent === 'feather-icon' &&
          colorHighlight('icon', option, ['color'])
        "
      />
      <span
        :class="colorHighlight('label', option, ['color'])
      ">
        {{option.label ? option.label : ''}}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      default: () => [
        {
          label: 'nenhuma',
          icon: 'ActivityIcon',
          value: null,
          color: 'primary',
          classes: {
            icon: 'font-bold',
            label: 'font-medium'
          }
        }
      ]
    },
    iconComponent: {
      type: String,
      default: 'feather-icon'
    },
    model: {
      type: Object,
    },
    highlight: {
      type: String,
      default: 'color'
    }
  },

  model: {
    prop: 'model',
    event: 'input'
  },

  data: () => ({

  }),

  methods: {
    input(val) {
      this.$emit('input', val)
    },
    highlightStyle(highlight, color, val) {
      const borderDefinition = 'border-1 border-b-0 border-t-0 border-r-0 border-solid'
      const styles = {
        borderStyle: `${borderDefinition} border-${color} `,
        colorStyle: `text-${color}`,
        backgroundStyle: `bg-${color}`
      }
      
      return this.check(val) ? styles[`${highlight}Style`] : ''
    },
    check(val) {
      return this.model === val
    },
    colorHighlight(element, option, onlyIf = ['color', 'border', 'background']) {
      const val = option.value
      const color = option.color
      const extra = option.classes[element]
      const highlighter = option.highlighter || this.highlight

      const colorized = this.highlightStyle(highlighter, color, val)
      const result = [
        onlyIf.includes(highlighter) ? colorized : '',
        extra
      ]
      return result
    }
  }
}
</script>